import Phaser from 'phaser';
import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.GenderSelect.Selector = function (scene, parent, selectorCfg, onClickCallback) {
  this.scene = scene;
  this.parent = parent;
  this.config = selectorCfg;
  this.background = null;
  this.textNormal = null;
  this.textLight = null;
  this.signNormal = null;
  this.signLight = null;
  this.character = null;
  this.x = 0;
  this.y = 0;
  this.cursorManager = scene.cursorManager;
  this.onClickCallback = onClickCallback;

  this.size = {
    width: 0,
    height: 0,
  };

  return this;
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.create = function (x = 0, y = 0) {
  this.x = x;
  this.y = y;

  this.background = this.scene.add.sprite(this.x, this.y, this.config.background);
  this.background.x += this.background.width / 2;
  this.background.y += this.background.height / 2;

  const bgX = this.background.x;
  const bgY = this.background.y;

  this.textNormal = this.scene.add.sprite(bgX, bgY - this.background.height / 2 + 80,
    this.config.textNormal);
  this.textLight = this.scene.add.sprite(bgX, bgY - this.background.height / 2 + 80,
    this.config.textLight);
  this.textLight.setAlpha(0);
  this.textNormal.setScale(1.3);
  this.textLight.setScale(1.3);

  this.character = this.scene.add.sprite(bgX, bgY - 40, this.config.character);

  let offset = { x: 0, y: 0 };

  if (Object(this.config).length > 0) {
    offset = this.config.signOffset;
  }
  this.signNormal = this.scene.add.sprite(bgX + 12 + offset.x,
    bgY + 450 + offset.y, this.config.signNormal);
  this.signLight = this.scene.add.sprite(bgX + 12 + offset.x,
    bgY + 450 + offset.y, this.config.signLight);
  this.signLight.setAlpha(0);

  this.size.width = this.background.displayWidth;
  this.size.height = this.background.displayHeight;

  this.cursorManager.setDefaultDraggableEvents(this.background);
  this.background.setInteractive(
    new Phaser.Geom.Rectangle(0, 0, this.size.width, this.size.height),
    Phaser.Geom.Rectangle.Contains,
  );
  this.background.on('pointerover', this.pointerOver, this);
  this.background.on('pointerout', this.pointerOut, this);
  this.background.on('pointerup', this.pointerUp, this);

  this.parent.add([this.background, this.textNormal,
    this.textLight, this.character, this.signNormal, this.signLight]);

  return this;
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.getSize = function () {
  return this.size;
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.getPosition = function () {
  return { x: this.x, y: this.y };
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.pointerUp = function () {
  this.scene.tweens.add({
    targets: [this.background, this.character, this.signNormal, this.signLight],
    scaleX: '-=0.1',
    scaleY: '-=0.1',
    duration: 75,
    ease: 'Linear',
    yoyo: true,
  });
  if (this.onClickCallback) this.onClickCallback();
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.pointerOver = function () {
  const duration = 100;
  this.scene.tweens.add({
    targets: [this.textLight, this.signLight],
    alpha: 1,
    duration,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.GenderSelect.Selector.prototype.pointerOut = function () {
  const duration = 100;
  this.scene.tweens.add({
    targets: [this.textLight, this.signLight],
    alpha: 0,
    duration,
    ease: 'Linear',
  });
};

export default EDC.Games.GenderSelect.Selector;
